import { Client, Coach } from "@/types/page";

export function homePageFor(user: Client | Coach | null): string {
    if (!user) {
        return route("home");
    }

    if (user.type === "client") {
        return route("chat");
    }

    // Only the server knows which intake step a coach who has not finished onboarding is on.
    return user.completed_onboarding_at
        ? route("coach.clients")
        : route("coach.dashboard");
}
